import { render } from "./list.vue?vue&type=template&id=5cc7dea6&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"

import "./list.vue?vue&type=style&index=0&id=5cc7dea6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5cc7dea6"

export default script